import {BewerbRunde} from "@/services/data/meisterschaften/bewerbRunde";
import {BewerbSpiel} from "@/services/data/meisterschaften/bewerbSpiel";
import FirebaseWrite from "@/services/database/firebaseWrite";
import {getGameGridForNoOfTeams} from "@/services/data/meisterschaften/gameGridFunctions";
import {LABEL_BEWERB_KO_PLATZ_3_BIS_4} from "@/services/data/meisterschaften/bewerb_constants";

export class BewerbRundeKo extends BewerbRunde {
    constructor(bewerbRunde, id, bewerbSettings, anzahlSpiele) {
        super(bewerbRunde, id, bewerbSettings);
        this.settings.anzahlSpiele = bewerbRunde?.settings?.anzahlSpiele??anzahlSpiele
        this.settings.spiel = bewerbRunde?.settings?.spiel??bewerbSettings?.spiel
        this.settings.bahnen = bewerbRunde?.settings?.bahnen??{von: null, bis: null}
        this.settings.startZeit = bewerbRunde?.settings?.startZeit??null
        const spiele = {}
        if ( bewerbRunde?.spiele ) {
            Object.keys(bewerbRunde.spiele).forEach( (spielId) => {
                spiele[spielId] = new BewerbSpiel(bewerbRunde.spiele[spielId], spielId, this.settings?.spiel?.saetze)
            })
        }
        this.spiele = spiele
        this.setRundenName()
    }

    setRundenName() {
        if ( this.settings.name ) return
        switch (this.settings.anzahlSpiele) {
            case 1: this.settings.name = "Finale"; break;
            case 2: this.settings.name = "Halbfinale"; break;
            case 4: this.settings.name = "Viertelfinale"; break;
        }
    }

    isComplete() {
        const spiele = Object.values(this.spiele)
        const unfinished = spiele.filter( (spiel) => !spiel.winner ).length
        return unfinished === 0
    }

    getSpiele(dauerGeplant) {
        const spiele = Object.values(this.spiele).sort((a, b) => a.id > b.id ? 1 : -1);
        let startZeit = this.settings.startZeit
        let currentBahn = this.settings.bahnen?.von
        const spieleRaster = spiele[0].id === 1 && this.id > 10 ?
            getGameGridForNoOfTeams(this.settings.anzahlSpiele * 2 ) : null
        for ( let i = 0; i < spiele.length; i++ ) {
            const spiel = spiele[i]
            const spielVonVorherigerRunde = (spiel.id - this.settings.anzahlSpiele * 2 + i)
            if ( !spieleRaster && this.id > 10 ) {
                const spielLabel = !spiel.isLooserGame ? 'SIEGER ' : 'VERLIERER '
                if ( !spiel.team1 ) spiel.team1Empty = spielLabel + "SPIEL " + spielVonVorherigerRunde
                if ( !spiel.team2 ) spiel.team2Empty = spielLabel + "SPIEL " + (spielVonVorherigerRunde + 1)
            } else if ( spieleRaster ) {
                if ( !spiel.team1 ) spiel.team1Empty = "QUALI " + spieleRaster[spiel.id].team1Id
                if ( !spiel.team2 ) spiel.team2Empty = "QUALI " + spieleRaster[spiel.id].team2Id
            }
            if ( currentBahn ) {
                spiel.startZeit = startZeit
                spiel.bahn1 = currentBahn??null
                currentBahn ++
                spiel.bahn2 = currentBahn??null
                currentBahn ++
                if ( currentBahn > this.settings.bahnen?.bis ) {
                    currentBahn = this.settings.bahnen?.von
                    startZeit = this.getNextStartZeit(startZeit, dauerGeplant)
                }
            }
        }
        return spiele
    }

        getNextStartZeit(startZeit, dauerGeplant) {
            if ( !startZeit || !dauerGeplant ) return startZeit
            let [hZeit, mZeit] = startZeit.split(':')
            let [hDauer, mDauer] = dauerGeplant.split(':')
            hZeit = parseInt(hZeit)
            mZeit = parseInt(mZeit)
            hDauer = parseInt(hDauer)
            mDauer = parseInt(mDauer)
            if ( mZeit + mDauer > 60 ) {
                hZeit = hZeit + 1
                mZeit = mZeit + mDauer - 60
            } else {
                mZeit = mZeit + mDauer
            }
            hZeit+=hDauer
            return hZeit + ':' + mZeit
        }

    initSpiele(idErstesSpiel, hatPlatzierungsSpiele){
        this.spiele = {}
        const labels = !hatPlatzierungsSpiele ? null : this.settings.anzahlSpiele === 1 ?
                                                        LABEL_BEWERB_KO_PLATZ_3_BIS_4 : null
        if ( hatPlatzierungsSpiele ) {
            for ( let i = 0; i < this.settings.anzahlSpiele; i++ ) {
                this.spiele[idErstesSpiel + i] = new BewerbSpiel(
                    null, idErstesSpiel + i, this.settings?.spiel?.saetze,
                    labels ? labels[i] : null, true
                )
            }
        }
        for ( let i = 0; i < this.settings.anzahlSpiele; i++ ) {
            const spielId = !hatPlatzierungsSpiele ? idErstesSpiel + i : idErstesSpiel + this.settings.anzahlSpiele + i
            this.spiele[spielId] = new BewerbSpiel(
                null, spielId, this.settings?.spiel?.saetze,
                labels ? labels[ this.settings.anzahlSpiele + i] : null
            )
        }
        if ( labels ) this.settings.name = labels.title
        return this.settings.anzahlSpiele + idErstesSpiel
    }

    checkForDuplicatePlayers(team, isDouble, spielId, teamKey) {
        const spiele = Object.values(this.spiele)
        const usedPlayers = new Map()
        for ( let i = 0; i < spiele.length; i++ ) {
            const team1 = spiele[i].team1?.settings
            const team2 = spiele[i].team2?.settings
            if ( spielId === spiele[i].id ) {
                if ( teamKey === 'team1' ) {
                    if ( team2 && team2?.player1?.id ) usedPlayers.set(team2?.player1?.id, true)
                    if ( team2 && team2?.player2?.id ) usedPlayers.set(team2?.player2?.id, true)
                } else {
                    if ( team1 && team1?.player1?.id ) usedPlayers.set(team1?.player1?.id, true)
                    if ( team1 && team1?.player2?.id ) usedPlayers.set(team1?.player2?.id, true)
                }
            } else {
                if ( team1 && team1?.player1?.id ) usedPlayers.set(team1?.player1?.id, true)
                if ( team1 && team1?.player2?.id ) usedPlayers.set(team1?.player2?.id, true)
                if ( team2 && team2?.player1?.id ) usedPlayers.set(team2?.player1?.id, true)
                if ( team2 && team2?.player2?.id ) usedPlayers.set(team2?.player2?.id, true)
            }
        }
        if ( !isDouble ) {
            if ( usedPlayers.get(team.settings.player1?.id) === true )
                return 'Diese Person wird in dieser Runde bereits verwendet. Bitte wähle eine andere Person aus.'
        } else {
            if ( usedPlayers.get(team.settings.player1?.id) === true ||
                 usedPlayers.get(team.settings.player2?.id) === true )
                return 'Zumindest eine Person dieses Teams wird in dieser Runde bereits in einem anderen Team ' +
                    'verwendet. Bitte wähle eine andere Person aus.'
        }
        return ''
    }

    teamsNotEmpty(){
        const spiele = Object.values(this.spiele)
        for ( let i = 0; i < spiele.length; i++ ) {
            if ( spiele[i].team1 || spiele[i].team2 ) return true
        }
        return false
    }

    async fillFromPreviousRunde(previousRunde, bewerbId, bewerbSettings) {
        if ( previousRunde.settings.modus === 'ko' ) {
            this.fillFromPreviousRundeKo(previousRunde)
        } else {
            this.fillFromPreviousRundeTab(previousRunde, bewerbSettings)
        }
    // update in Bewerb
        return await FirebaseWrite.update('meisterschaftenBewerbe', bewerbId,
            {['runden.' + this.id + '.spiele']: JSON.parse(JSON.stringify(this.spiele)) }
        )
    }
        fillFromPreviousRundeKo(previousRunde) {
            const previousRundeSpiele = Object.values(previousRunde.spiele)
        // get first spielId von dieser Runde
            const spieleKeys = Object.keys(this.spiele).map(id => parseInt(id))
            let spielId = spieleKeys.sort( (a, b) => a > b ? 1 : -1)[0]
        // loop through previousRundeSpiele and fill this.spiele
            for ( let i = 0; i < previousRundeSpiele.length; i++ ) {
                const previousWinnerKey = previousRundeSpiele[i].winner
                if ( this.spiele[spielId].isLooserGame ) {
                    const spiel = this.spiele[spielId]
                    const previousLooserKey = previousWinnerKey === 'freilos' ? null : previousWinnerKey === 'team1' ? 'team2' : 'team1'
                    const team = previousWinnerKey === 'freilos' ? null : previousRundeSpiele[i][previousLooserKey]
                    if((!spiel.winner || spiel.team1Freilos || spiel.team2Freilos) && previousWinnerKey) {
                        this.fillFromPreviousRundeKoGame(spiel, team, i)
                    } else if ( (!spiel.winner || spiel.team1Freilos || spiel.team2Freilos) &&
                        !previousWinnerKey ) this.clearFromPreviousRundeKoGame(spiel, i)
                }
                const previousWinnerTeam = previousRundeSpiele[i][previousWinnerKey]
                const winnerTeam = previousWinnerKey !== 'freilos' ? previousWinnerTeam : null
                const winnerSpielId = this.spiele[spielId].isLooserGame ? spielId + this.settings.anzahlSpiele : spielId
                const spiel = this.spiele[winnerSpielId]
                if((!spiel.winner || spiel.team1Freilos || spiel.team2Freilos) && previousWinnerKey) {
                    this.fillFromPreviousRundeKoGame(spiel, winnerTeam, i)
                } else if ( (!spiel.winner || spiel.team1Freilos || spiel.team2Freilos) &&
                    !previousWinnerKey ) this.clearFromPreviousRundeKoGame(spiel, i)
                if ( (i+1) % 2 === 0 ) spielId++
                delete spiel.team1Empty
                delete spiel.team2Empty
            }
        }
            fillFromPreviousRundeKoGame(spiel, team, i) {
                spiel.winner = ''
                if ( (i+1) % 2 !== 0 ) {
                    spiel.team1 = null
                    delete spiel.team1Freilos
                    spiel.team1 = team
                    if ( !team) spiel.team1Freilos = true
                } else {
                    spiel.team2 = null
                    delete spiel.team2Freilos
                    spiel.team2 = team
                    if ( !team) spiel.team2Freilos = true
                    spiel.winner = spiel.team1Freilos && spiel.team2Freilos ? 'freilos' :
                                    spiel.team1Freilos ? 'team2' : spiel.team2Freilos ? 'team1' : ''
                }
            }
            clearFromPreviousRundeKoGame(spiel, i) {
                spiel.winner = ''
                if ( (i+1) % 2 !== 0 ) {
                    spiel.team1 = null
                    delete spiel.team1Freilos
                } else {
                    spiel.team2 = null
                    delete spiel.team2Freilos
                }
            }

        fillFromPreviousRundeTab(previousRunde, bewerbSettings){
            const numberOfPlayers = this.settings.anzahlSpiele * 2
            const spieleRaster = getGameGridForNoOfTeams(numberOfPlayers)
            const nachruecken = bewerbSettings.anzahlStarterMax > bewerbSettings.teamsToKoMax
            const previousRundeTeams = nachruecken ?
                Object.values(previousRunde.teams)
                    .filter( (team) => team.results.status === 'finished')
                    .sort((a, b) => a.results.position > b.results.position ? 1 : -1)
                    .slice(0, bewerbSettings.teamsToKoMax) :
                Object.values(previousRunde.teams)
                    .filter( (team) => team.results.position <= numberOfPlayers )
                    .sort((a, b) => a.results.position > b.results.position ? 1 : -1)
            for ( let i = 1; i <= previousRundeTeams.length; i++ ) {
                const team = previousRundeTeams[i-1]
                team.results.positionForFill = i
            }
            Object.keys(this.spiele).forEach( (spielId) => {
                const spiel = this.spiele[spielId]
                this.fillFromPreviousRundeTabCleanTeam(spiel, 'team1', previousRundeTeams,
                    spieleRaster, spielId, nachruecken
                )
                this.fillFromPreviousRundeTabCleanTeam(spiel, 'team2', previousRundeTeams,
                    spieleRaster, spielId, nachruecken
                )
                spiel.winner = spiel.team1Freilos && spiel.team2Freilos ? 'freilos' :
                               spiel.team1Freilos ? 'team2' : spiel.team2Freilos ? 'team1' : ''
                delete spiel.team1Empty
                delete spiel.team2Empty
            })
        }

        fillFromPreviousRundeTabCleanTeam(spiel, teamKey, previousRundeTeams, spieleRaster, spielId, nachruecken) {
            const teamId = teamKey + 'Id'
            let team = previousRundeTeams.find( (team) => team.results.positionForFill === spieleRaster[spielId][teamId])??null
            if ( (team && nachruecken) || (team && !nachruecken && team.results.status === 'finished') ) {
                team = JSON.parse(JSON.stringify(team))
                team.settings.name += ' (' + team.results.position + ')'
                delete team.results
                spiel[teamKey] = team
            } else {
                const freiLosKey = teamKey + 'Freilos'
                spiel[freiLosKey] = true
                spiel[teamKey] = null
            }
        }
}